// extracted by mini-css-extract-plugin
export default {"fadeSlider":"FadeImageSlider_fadeSlider__URNWF","fadeImage":"FadeImageSlider_fadeImage__BOowk","active":"FadeImageSlider_active__4VXyP"};